import type { Msg } from '@halo/chat-sdk-react';

export interface MsgFilePreviewContentProps {
  message: Msg;
}

export const MsgFilePreviewContent = memo(function MsgFilePreviewContent({
  message,
}: MsgFilePreviewContentProps) {
  const { t } = useTranslation();
  return `[${t('chat.fileText')}] ${message?.payload?.name}`;
});
